import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewGastoEstructura = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'gasto_estructura_mensual',
        name: 'Gasto Estructura',
        component: ViewGastoEstructura,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
